import { Fragment, useMemo } from "react";
import type { QuoteLineMO } from "~/features/orders/common/components/v2/models";
import type { RenderCboxFn } from "~/features/orders/common/components/v2/QuoteTable/types";
import type { QuoteSelectionStateProps } from "~/features/orders/common/components/v2/QuoteTable/useQuoteDetailsSelectionState";
import { groupByMainQuoteLine } from "~/features/orders/common/components/v2/QuoteTable/utils";
import { SimpleQuoteRow } from "../quoteListV2/SimpleQuoteRow";
import { AdvancedQuoteRow } from "../quoteListV2/AdvancedQuoteRow";
import { Checkbox, Stack } from "~/common/mui";

interface QuoteTableProps extends Partial<QuoteSelectionStateProps> {
  quoteLines: QuoteLineMO[];
  showCheckboxes: boolean;
  classes?: {
    headerCheckbox?: string;
    lineItemCheckbox?: string;
  };
}

export const QuoteDetailsTableV2 = ({ quoteLines, ...rest }: QuoteTableProps) => {
  const groupedLines = useMemo(() => groupByMainQuoteLine(quoteLines), [quoteLines]);

  // Checkbox rendering
  let renderQuoteLineCheckbox: RenderCboxFn = () => null;

  if (rest.showCheckboxes) {
    const { selectedLineNos, toggleLine } = rest as QuoteSelectionStateProps;

    if (rest.toggleLine) {
      renderQuoteLineCheckbox = (quoteLine: QuoteLineMO) => (
        <Checkbox
          sx={{ padding: "0px" }}
          disabled={quoteLine.disabled}
          checked={selectedLineNos[quoteLine.lineNo] ?? false}
          onChange={() => toggleLine(quoteLine.lineNo)}
        />
      );
    }
  }

  return (
    <Stack gap={2}>
      {/* Quote Groups */}
      {groupedLines.map((group) => (
        <Fragment key={group.mainQuoteLine.lineNo}>
          {group.alternativeQuoteLines.length === 0 ? (
            <SimpleQuoteRow quoteLine={group.mainQuoteLine} renderCheckbox={renderQuoteLineCheckbox} />
          ) : (
            <AdvancedQuoteRow {...group} renderCheckbox={renderQuoteLineCheckbox} />
          )}
        </Fragment>
      ))}
    </Stack>
  );
};
